module.exports = __webpack_public_path__ + "img/assuraf.7703f717.png";